import { ProductUsage, ProductCategory, ProductIngredient } from './index';

export const NEW_PRODUCT_ID = 'b19768a0a7b911eea4020242ac141402';

export interface Product  {
    productID: string;
    productName: string;

    categoriesString?: string;
    mainCategory?: string;
    categories?: ProductCategory[];
    ingredients?: ProductIngredient[];
    usages?: ProductUsage[];

    forFertigation: boolean;
    isNutrition?: boolean;

    imageURL?: string;
    shortName?: string;
    alias2?: string;
    formulationID?: string;
    toxicologyGroup?: string;

    isDirty?: boolean;
    isRegisteredProduct?: boolean;
}

export const blankProduct: Product = {
    productID:  '',
    productName : '',
    shortName: '',
    alias2: '',
    formulationID: '',
    toxicologyGroup: '',
    isDirty: true,
    categories: [],
    forFertigation: false,
    isNutrition: false,
    ingredients: [],
    isRegisteredProduct: false
};



